import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientAlertList } from '../types';

const useNexhealthPatientAlerts = (
    agentId: string,
    patientId?: number,
    enabled = false,
) => useHttpQuery<NexhealthPatientAlertList>({
    pathname: `/organizations/${agentId}/apps/nexhealth/patients/${patientId}/alerts`,
    server: ACTIONS_BASE_URL,
    key: ['nexhealth', 'patient-alerts', agentId, patientId],
    queryOptions: {
        enabled: Boolean(agentId && patientId) && enabled,
        retry: false,
    },
});

export default useNexhealthPatientAlerts;
